// extracted by mini-css-extract-plugin
module.exports = {"main-component":"eventsEmpty_main-component__1DG80"};